import type { LogStartPerformanceUsage } from 'owa-analytics-start';

const ATTEMPT_COUNT = '_AttemptCount';
const BACKOFF_MS = '_BackoffMs';
const MESSAGE = '_Message';
const STACK = '_Stack';

export function recordRetryAttempt(
    perfLog: LogStartPerformanceUsage,
    prefix: string,
    attemptIndex: number,
    backoffAccumulatedMs: number
): void {
    perfLog.addCustomProperty(prefix + ATTEMPT_COUNT, attemptIndex);
    perfLog.addCustomProperty(prefix + BACKOFF_MS, backoffAccumulatedMs);
}

export function recordRetryFailure(
    perfLog: LogStartPerformanceUsage,
    prefix: string,
    error:
        | {
              message?: string;
              stack?: string;
          }
        | undefined,
    attemptIndex: number,
    backoffAccumulatedMs: number
): void {
    perfLog.addCustomProperty(prefix + MESSAGE, error?.message ?? '');
    perfLog.addCustomProperty(prefix + STACK, error?.stack ?? '');
    perfLog.addCustomProperty(prefix + ATTEMPT_COUNT, attemptIndex);
    perfLog.addCustomProperty(prefix + BACKOFF_MS, backoffAccumulatedMs);
}
